export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/menu-icon.92c04760.svg","height":18,"width":20};